// extracted by mini-css-extract-plugin
module.exports = {"check":"IconCheck_check__1G5qV","behind":"IconCheck_behind__20EjL"};